<template>
    <v-modal
        :name="modalName"
        :width="350"
        height="auto"
    >
        <div class="wrapper">
            <v-input class="wrapper__input" :value="href" readonly />
            <v-button type="primary" @click.native="copy">{{ $t('COPY') }}</v-button>
        </div>

        <template #footer>
          <v-button @click.native="$modal.hide(modalName)">{{ $t('CANCEL') }}</v-button>
        </template>
    </v-modal>
</template>

<script>
import copyToClipboard from 'copy-text-to-clipboard';
import VModal from '@/components/VModal.vue';
import VInput from '@/components/VInput.vue';
import VButton from '@/components/Button.vue';

export default {
  components: {
    VModal,
    VInput,
    VButton,
  },
  data() {
    return {
      modalName: 'sharePage',
    };
  },
  computed: {
    href() {
      const url = new URL(this.$route.fullPath, location.origin);
      return url.toString();
    },
  },
  methods: {
    copy() {
      const isCopied = copyToClipboard(this.href);
      if (isCopied) {
        this.$notify({
          type: 'success',
          text: this.$t('SHARE_LINK_COPIED'),
        });
        this.$modal.hide(this.modalName);
        return;
      }

      this.$notify({
        type: 'error',
        text: this.$t('SOMETHING_WENT_WRONG'),
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
    display: flex;
    gap: 5px;

    &__input {
        flex-grow: 1;
    }
}
</style>
